// Formatação de EXIBIÇÃO e parse-DE-VOLTA das células da planilha na tela.
// Exibição espelha os numFmt do Excel (data DD/MM/YYYY, número pt-BR 2 casas, tarifa 6
// casas). Na edição faz o caminho inverso: string digitada → valor CRU (serial/number),
// para o reexport sair idêntico ao que o Excel produziria.
import { parseBrNum, dateToSerial, type ColType } from './faturaGridModel';

const EPOCH = new Date(1899, 11, 30).getTime();

/** Serial Excel → 'DD/MM/YYYY'. */
function serialToBr(serial: number): string {
  const d = new Date(EPOCH + serial * 86400000);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${d.getFullYear()}`;
}

/** Valor cru da matriz → texto exibido na célula (respeitando o tipo da coluna). */
export function formatCell(value: string | number, type: ColType): string {
  if (value === '' || value === null || value === undefined) return '';
  if (type === 'date') return typeof value === 'number' ? serialToBr(value) : String(value);
  if (type === 'num' || type === 'dec6') {
    if (typeof value === 'number') {
      const casas = type === 'dec6' ? 6 : 2;
      return value.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
    }
    return String(value);
  }
  return String(value);
}

/** Texto que o usuário digitou → valor cru para gravar na matriz editada. */
export function parseCell(input: string, type: ColType): string | number {
  const s = input.trim();
  if (s === '') return '';
  if (type === 'date') return dateToSerial(s);      // aceita DD/MM/YYYY e ISO; senão devolve o texto
  if (type === 'num' || type === 'dec6') return parseBrNum(s);
  return input;
}

/** Valor inicial do input ao entrar em edição — mostra o texto formatado (editável). */
export function editableText(value: string | number, type: ColType): string {
  return formatCell(value, type);
}
